const productTypes = {
  COMMERCIAL: "Commercial",
  RETAIL: "Retail",
}
export default productTypes;
